import * as React from "react";
import styled from "@mui/material/styles/styled";
import Chip from "@mui/material/Chip";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { categoryIcons } from "../categoryIcons";

//region [[ Styles ]]
const OrganChip = styled(Chip)(({ selected }: { selected: boolean }) => ({
  borderRadius: "4px",
  marginRight: "5px",
  marginBottom: "2.5px",
  marginTop: "2.5px",
  height: "28px",
  borderColor: selected ? RosebudColorMap.purple2 : "#d5d5d5",
  fontSize: "14px",
  fontWeight: selected ? "normal" : "normal",
  color: RosebudColorMap.navy,
  transition: "all 0.1s ease-in",
}));

export const IconStyle = styled("div")(({ theme }) => ({
  marginTop: "1px",
  paddingLeft: "3px",
  opacity: 0.8,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SubCategoryChipProps {
  className?: string;
  onClick: () => void;
  label: string;
  selected: boolean;
  id: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SubCategoryChip = ({ ...props }: SubCategoryChipProps) => {
  const getCategroyIcon = () => {
    return (
      <IconStyle className={props.className}>
        <i className={categoryIcons[props.label]} />
      </IconStyle>
    );
  };

  return (
    <OrganChip
      className={props.className}
      label={props.label}
      selected={props.selected}
      variant="outlined"
      icon={getCategroyIcon()}
      onClick={props.onClick}
    />
  );
};
